import Header from '../../components/layout/Header/Header';
import Footer from '../../components/layout/Footer/Footer';
import WhatsAppButton from '../../components/ui/WhatsAppButton/WhatsAppButton';
import Seo from '../../components/utils/Seo';
import ProjectCard from '../../sections/Projects/ProjectCard/ProjectCard';
import { getAllProjects, getFeaturedProject } from '../../data/projects';
import './Projects.css';

export default function Projects() {
  const projects = getAllProjects();
  const featured = getFeaturedProject();
  const others = projects.filter((p) => p.slug !== featured?.slug);

  return (
    <div className="projects-page">
      <Seo
        title="Our Projects"
        description="NimbleCasa's portfolio of residential developments and investment opportunities across Lagos."
        path="/projects"
      />
      <Header />

      <main className="projects-page__main">
        <section className="projects-intro">
          <div className="projects-intro__inner">
            <p className="eyebrow">Portfolio</p>
            <h1 className="projects-intro__title">
              Our <em>Projects</em>
            </h1>
            <p className="projects-intro__sub">
              NimbleCasa develops and represents premium residential
              developments across Lagos. Below is our current portfolio of
              projects and investment opportunities.
            </p>
            <p className="projects-intro__count">
              {projects.length} development{projects.length !== 1 ? 's' : ''}
            </p>
          </div>
        </section>

        <section className="projects-list">
          <div className="projects-list__inner">
            {featured && (
              <div className="projects-list__featured">
                <ProjectCard project={featured} featured />
              </div>
            )}

            {others.length > 0 && (
              <div className="projects-list__grid">
                {others.map((project) => (
                  <ProjectCard key={project.slug} project={project} />
                ))}
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
